import { createSlice } from "@reduxjs/toolkit";
import {
  ChemistryResult,
  DEProcess,
  Heating,
  ProcessPhase,
} from "../models/eaf.models";
import { Pourback } from "../models/ms.models";

const DataEntryReducerInitialState: {
  isDataLoading: boolean;
  isSubmitLoading: boolean;
  errorMessage: string;
  notificationMessage: string;
  phases: ProcessPhase[];
  pourbacks: Pourback[];
  chemistry: ChemistryResult[];
  heatings: Heating[];
  deProcess: DEProcess | null;
  lastUpdate: Date;
} = {
  errorMessage: "",
  notificationMessage: "",
  isDataLoading: false,
  isSubmitLoading: false,
  phases: [],
  pourbacks: [],
  chemistry: [],
  heatings: [],
  deProcess: null,
  lastUpdate: new Date(),
};

export const DataEntryReducer = createSlice({
  name: "__",
  initialState: DataEntryReducerInitialState,
  reducers: {
    setIsDataLoading(state, { payload }) {
      state.isDataLoading = payload;
    },
    setIsSubmitLoading(state, { payload }) {
      state.isSubmitLoading = payload;
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setNotificationMessage(state, { payload }) {
      state.notificationMessage = payload;
    },
    setDEProcess(state, { payload }) {
      state.deProcess = payload;
    },
    setPhases(state, { payload }) {
      state.phases = payload;
    },
    setPourbacks(state, { payload }) {
      state.pourbacks = payload;
    },
    setHeatings(state, { payload }) {
      state.heatings = payload;
    },
    setChemistry(state, { payload }) {
      state.chemistry = payload;
    },
    setProcess(state, { payload }) {
      if (state.deProcess) {
        state.deProcess.process = payload;
      }
    },
    setLastUpdate(state) {
      state.lastUpdate = new Date();
    },
  },
});
